import { getTypeOrNull, useInitiativeQuery } from '@spotify/confidence-graphql';
import {
  ActivityChangeOptions,
  DeltaText,
  createActivityChangeExtension,
} from '@spotify/plugin-confidence-activity-react';

const InitiativeChangeRender = ({ change }: ActivityChangeOptions) => {
  const newValue = change.newValue as string | null;
  const oldValue = change.oldValue as string | null;

  const { data: newData } = useInitiativeQuery({
    variables: { name: newValue ?? '' },
    skip: !newValue,
    fetchPolicy: 'cache-first',
  });
  const { data: oldData } = useInitiativeQuery({
    variables: { name: oldValue ?? '' },
    skip: !oldValue,
    fetchPolicy: 'cache-first',
  });

  const oldText =
    getTypeOrNull(oldData?.initiative)?.displayName || oldValue || '';
  const newText =
    getTypeOrNull(newData?.initiative)?.displayName || newValue || '';

  return <DeltaText oldText={oldText} newText={newText} disableDiff />;
};

export const INITIATIVE_CHANGE_EXTENSION = createActivityChangeExtension({
  id: 'initiative-change',
  predicate: ({ change }) => change.fieldPath === '/initiatives',
  render: InitiativeChangeRender,
});
